import React, { useEffect } from "react";
import { Combobox, Toast } from "../..";
import { useState } from "react";
import AddOffice from "../../Admin/Add/office";
import { apis, get } from "../../../Utils/axios";

function OfficeSearch({ onSelect = () => {}, placeholder = "Search Offices", label, selected = {}, className = "", prefetch = true }) {
	const [AllOffices, setAllOffices] = useState([]);
	const [Loader, setLoader] = useState();

	const fetchOffices = (query) => {
		setLoader(true);
		const params = { page: 1 };
		if (query) {
			params.search = query;
		}

		get(apis.getAllOffices, params, (r, e) => {
			if (r) {
				setAllOffices(r.offices);
				setLoader(false);
			} else if (e) {
				console.log(e);
				Toast.handleError(e);
				setLoader(false);
			}
		});
	};

	const onChange = (query) => {
		fetchOffices(query);
	};

	useEffect(() => {
		if (prefetch) {
			fetchOffices("");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [prefetch]);

	return (
		<div className="flex items-end w-full gap-2">
			<Combobox
				loading={Loader}
				label={label}
				placeholder={placeholder}
				className={className}
				onChange={onChange}
				options={AllOffices.map((office) => ({
					...office,
					label: office.name,
					value: office.id,
				}))}
				selected={selected}
				onSelect={onSelect}
			/>
			<AddOffice btnLabel="+ New" />
		</div>
	);
}

export default OfficeSearch;
